import { render, staticRenderFns } from "./BadgeContent.vue?vue&type=template&id=ea4be87c"
import script from "./BadgeContent.vue?vue&type=script&lang=js"
export * from "./BadgeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports